import {
    Phone, Mail, Users, Eye, MessageSquare,
    AlertCircle, PhoneCall, CalendarCheck, Clock, UserCheck, UserX
} from 'lucide-react';

export const STATUS_CONFIG = {
    new: { label: 'Nouveau', color: 'bg-blue-500', textColor: 'text-blue-500', icon: AlertCircle },
    contacted: { label: 'Contacté', color: 'bg-yellow-500', textColor: 'text-yellow-500', icon: PhoneCall },
    demo_scheduled: { label: 'Démo planifiée', color: 'bg-purple-500', textColor: 'text-purple-400', icon: CalendarCheck },
    callback: { label: 'En rappel', color: 'bg-orange-500', textColor: 'text-orange-500', icon: Clock },
    converted: { label: 'Converti', color: 'bg-green-500', textColor: 'text-green-500', icon: UserCheck },
    lost: { label: 'Perdu', color: 'bg-red-500', textColor: 'text-red-500', icon: UserX }
};

export const AGENCY_STATUS_CONFIG = {
    pending_documents: { label: 'Documents en attente', color: 'bg-yellow-500' },
    pending_payment: { label: 'Paiement en attente', color: 'bg-orange-500' },
    active: { label: 'Actif', color: 'bg-green-500' },
    suspended: { label: 'Suspendu', color: 'bg-red-500' }
};

export const NOTE_TYPES = [
    { value: 'call', label: 'Appel', icon: Phone },
    { value: 'email', label: 'Email', icon: Mail },
    { value: 'meeting', label: 'Réunion', icon: Users },
    { value: 'demo', label: 'Démo', icon: Eye },
    { value: 'note', label: 'Note', icon: MessageSquare }
];
